/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioVersionStatus } from './InternalApiScenarioVersionStatus';
import {
    InternalApiScenarioVersionStatusFromJSON,
    InternalApiScenarioVersionStatusFromJSONTyped,
    InternalApiScenarioVersionStatusToJSON,
    InternalApiScenarioVersionStatusToJSONTyped,
} from './InternalApiScenarioVersionStatus';

/**
 * 
 * @export
 * @interface InternalApiRiskRuleVersionUpdate
 */
export interface InternalApiRiskRuleVersionUpdate {
    /**
     * 
     * @type {InternalApiScenarioVersionStatus}
     * @memberof InternalApiRiskRuleVersionUpdate
     */
    status: InternalApiScenarioVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRuleVersionUpdate
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRuleVersionUpdate
     */
    details?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRuleVersionUpdate
     */
    content?: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiRiskRuleVersionUpdate
     */
    weight?: number;
}



/**
 * Check if a given object implements the InternalApiRiskRuleVersionUpdate interface.
 */
export function instanceOfInternalApiRiskRuleVersionUpdate(value: object): value is InternalApiRiskRuleVersionUpdate {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function InternalApiRiskRuleVersionUpdateFromJSON(json: any): InternalApiRiskRuleVersionUpdate {
    return InternalApiRiskRuleVersionUpdateFromJSONTyped(json, false);
}

export function InternalApiRiskRuleVersionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRiskRuleVersionUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'status': InternalApiScenarioVersionStatusFromJSON(json['status']),
        'note': json['note'] == null ? undefined : json['note'],
        'details': json['details'] == null ? undefined : json['details'],
        'content': json['content'] == null ? undefined : json['content'],
        'weight': json['weight'] == null ? undefined : json['weight'],
    };
}

export function InternalApiRiskRuleVersionUpdateToJSON(json: any): InternalApiRiskRuleVersionUpdate {
    return InternalApiRiskRuleVersionUpdateToJSONTyped(json, false);
}

export function InternalApiRiskRuleVersionUpdateToJSONTyped(value?: InternalApiRiskRuleVersionUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': InternalApiScenarioVersionStatusToJSON(value['status']),
        'note': value['note'],
        'details': value['details'],
        'content': value['content'],
        'weight': value['weight'],
    };
}

